import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import { connect } from 'react-redux';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IntlMessages from 'util/IntlMessages';
import { AccountActions } from '../../actions';

class UserInfo extends React.Component {
  state = {
    anchorEl: null,
    open: false,
  };

  componentDidMount() {
    console.log('Account - get user details');
    this.props.getUserDetails({
      cb: (res) => {
        console.log(res);
      },
    });
  }

  handleClick = (event) => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
    location.href = '/#/app/account';

    var basePath = window.location.hash;
    const menuLi = document.getElementsByClassName('menu');
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].classList.remove('open');
    }

    const activeLi = document.querySelector('a[href="' + basePath + '"]'); // select current a element
    const activeNav = this.closest(activeLi, 'ul'); // select closest ul
    if (activeNav.classList.contains('sub-menu')) {
      this.closest(activeNav, 'li').classList.add('open');
    } else {
      this.closest(activeLi, 'li').classList.add('open');
    }
  };

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(
        function (fn) {
          if (typeof document.body[fn] == 'function') {
            matchesFn = fn;
            return true;
          }
          return false;
        }
      );

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (error) {}

    return null;
  }

  handleLogout = () => {
    this.handleRequestClose();
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('expired_at');
    location.href = '/#/login';
  };

  render() {
    const { userData } = this.props;
    return (
      <div className="user-profile d-flex flex-row align-items-center">
        <Avatar alt="..." src="https://placehold.co/150x150?text=Photo" className="user-avatar " />
        <div className="user-detail">
          <h4 className="user-name" onClick={this.handleClick}>
            {userData.firstname} {userData.lastname} <i className="zmdi zmdi-caret-down zmdi-hc-fw align-middle" />
          </h4>
        </div>
        <Menu
          className="user-info"
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.handleRequestClose}
          PaperProps={{
            style: {
              width: 152,
              paddingTop: 0,
              paddingBottom: 0,
            },
          }}
        >
          <MenuItem onClick={this.handleRequestClose}>
            <i className="zmdi zmdi-account zmdi-hc-fw mr-2" />
            <IntlMessages id="pages.account" />
          </MenuItem>
          {/* <MenuItem onClick={this.handleRequestClose}>
                        <i className="zmdi zmdi-settings zmdi-hc-fw mr-2"/>
                        <IntlMessages id="popup.setting"/>
                    </MenuItem> */}
          <MenuItem onClick={this.handleLogout}>
            <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2" />

            <IntlMessages id="popup.logout" />
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  // const {locale} = settings;
  return {
    userData: state.AccountReducer.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserDetails: (req) => dispatch(AccountActions.getUserDetails(req.cb)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo);



// WEBPACK FOOTER //
// ./components/UserInfo/index.js